const solutions = [
  {
    url: "https://www.smartkarma.com/home/for-institutional-investors-financial-services/",
    title: "For Institutional Investors and Financial Services",
  },
  {
    url: "https://www.smartkarma.com/home/for-corporate-ir-strategy/",
    title: "For Corporate IR and Strategy",
  },
  {
    url: "https://www.smartkarma.com/home/for-private-wealth-intermediaries/",
    title: "For Private Wealth Intermediaries",
  },
  {
    url: "https://www.smartkarma.com/home/smartkarma-pricing/",
    title: "Pricing",
  },
  {
    url: "https://www.smartkarma.com/home/compare/",
    title: "How Smartkarma Compares",
  },
];

const about = [
  {
    url: "https://www.smartkarma.com/home/about-us/",
    title: "Who We Are",
  },
  {
    url: "https://www.smartkarma.com/home/careers/",
    title: "Careers",
  },
  {
    url: "https://www.smartkarma.com/home/faqs/",
    title: "FAQs",
  },
  {
    url: "https://www.smartkarma.com/home/research-provider-solutions/",
    title: "Research Provider Solutions",
  },
  {
    url: "https://www.smartkarma.com/home/syndicate-on-smartkarma/",
    title: "Syndicate your Publications",
  },
];

const legal = [
  {
    url: "https://www.smartkarma.com/home/compliance/",
    title: "Compliance",
  },
  {
    url: "https://www.smartkarma.com/home/terms-of-use/",
    title: "Terms of Use",
  },
  {
    url: "https://www.smartkarma.com/home/privacy-policy/",
    title: "Privacy Policy",
  },
  {
    url: "https://www.smartkarma.com/home/press-kit/",
    title: "Press Kit",
  },
  {
    url: "https://www.smartkarma.com/home/resources/rss-feeds/",
    title: "RSS Feeds",
  },
];

const contact = [
  {
    title: "Request a Free Trial",
    url: "https://www.smartkarma.com/home/investor-solutions/#form",
  },
  {
    title: "Avail a Transition Account",
    url: "https://www.smartkarma.com/home/professional-investor-solutions/transition-account/",
  },
  {
    title: "Guest Posts on Smartkarma",
    url: "https://www.smartkarma.com/home/guest-posts-on-smartkarma/",
  },
  {
    title: "Other Enquiries",
    url: "https://www.smartkarma.com/home/contact-our-team/",
  },
  {
    title: "Join TL;DR Community",
    url: "https://www.smartkarma.com/home/resources/tldr/",
  },
  {
    title: "Free Weekly Newsletters",
    url: "https://www.smartkarma.com/home/resources/weekly-newsletters/",
  },
];

export { about, contact, legal, solutions };
